// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: grid;
  grid-template-columns: [title-start] max-content [title-end center-start] 1fr [center-end action-start] auto [action-end];
  gap: 0.5rem 1rem;
}
.header .title {
  grid-column: title;
}
.header .center {
  grid-column: center;
}
.header .action {
  grid-column: action;
}

.bank-container {
  display: grid;
  grid-template-columns: [name] 1fr [iban] 1fr [bic] 1fr [status] 1fr;
  gap: 0.5rem;
}
.bank-container .name {
  grid-column: name;
}
.bank-container .iban {
  grid-column: iban;
}
.bank-container .bic {
  grid-column: bic;
}
.bank-container .status {
  grid-column: status;
}`, "",{"version":3,"sources":["webpack://./src/app/steppers/users/steps/bank-data/bank-data.step.sass"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yHAAA;EACA,gBAAA;AACJ;AAAI;EACI,kBAAA;AAER;AADI;EACI,mBAAA;AAGR;AAFI;EACI,mBAAA;AAIR;;AADA;EACI,aAAA;EACA,mEAAA;EACA,WAAA;AAIJ;AAHI;EACI,iBAAA;AAKR;AAJI;EACI,iBAAA;AAMR;AALI;EACI,gBAAA;AAOR;AANI;EACI,mBAAA;AAQR","sourcesContent":[".header\n    display: grid\n    grid-template-columns: [title-start] max-content [title-end center-start] 1fr [center-end action-start] auto [action-end]\n    gap: 0.5rem 1rem\n    .title\n        grid-column: title\n    .center\n        grid-column: center\n    .action\n        grid-column: action\n\n\n.bank-container\n    display: grid\n    grid-template-columns: [name] 1fr [iban] 1fr [bic] 1fr [status] 1fr\n    gap: 0.5rem\n    .name\n        grid-column: name\n    .iban\n        grid-column: iban\n    .bic\n        grid-column: bic\n    .status\n        grid-column: status"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
